import { useNavigate } from 'react-router-dom';

/**
 * Custom hook for handling navigation between different components
 * @returns {Object} Navigation utilities
 */
export const useNavigation = () => {
    const navigate = useNavigate();

    /**
     * Handle navigation item click
     * @param {string} itemId - The ID of the navigation item
     */
    const handleNavItemClick = (itemId) => {
        if (itemId !== 'settings') {
            switch (itemId) {
                case 'home':
                    navigate('/dashboard');
                    break;
                case 'memory':
                    navigate('/submissions');
                    break;
                case 'todos':
                    navigate('/todos');
                    break;
                case 'calendar':
                    navigate('/dashboard/calendar');
                    break;
                case 'feed':
                    navigate('/dashboard/feed');
                    break;
                case 'settings':
                    navigate('/settings');
                    break;
                default:
                    navigate('/dashboard');
            }
        }
    };

    /**
     * Navigate directly to a specific route
     * @param {string} route - The route to navigate to
     */
    const navigateTo = (route) => {
        navigate(route);
    };

    /**
     * Go back to previous page
     */
    const goBack = () => {
        navigate(-1);
    };

    /**
     * Replace current route (useful for redirects)
     * @param {string} route - The route to replace with
     */
    const replaceRoute = (route) => {
        navigate(route, { replace: true });
    };

    return {
        handleNavItemClick,
        navigateTo,
        goBack,
        replaceRoute,
        navigate // Expose the original navigate function for advanced use cases
    };
};